export const config = {
  getBaseUrl: () =>
    localStorage.getItem('chat-x_base_url') || 'https://api.coze.cn',
  getBaseWsUrl: () =>
    localStorage.getItem('chat-x_base_ws_url') || 'wss://ws.coze.cn',
  getPat: () => 'pat_MdKhFPLxqbgd0RfrKmCFMw3mKd9z4iSA4J8Y2AkOButSp6b1nScH9Qk8CZKDrIiD',
  getBotId: () => '7574615234275770374',
};
